// store/reducers/headerReducer.js

import { SET_HEADER_DATA, LOGOUT_USER } from "../actions/headerActions";

const initialState = {
  isLogin: false,
  ftk: "",
  userPhoto: "",
  loginUname: "",
  uId: "",
  clientId: "",
  enableOneTap: false,
  isDesktop: true,
  isMsite: false
};

export default function headerReducer(state = initialState, action) {
  switch (action.type) {
    case SET_HEADER_DATA:
      return {
        ...state,
        ...action.payload
      };

    case LOGOUT_USER:
      return {
        ...initialState
      };

    default:
      return state;
  }
}
